import { lazy } from 'react';

export const SetPassword = lazy(() => import('./SetPassword.component'));
